// Where the accept screen sends someone after they accept. Pure so the node
// test in scripts/tests/legal-content.ts can import it.

export const ACCEPT_TERMS_PATH = '/accept-terms';

/** Only same-app paths are followed after accepting. */
export function safeNextUrl(next: string | null | undefined): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\') || next.startsWith(ACCEPT_TERMS_PATH)) {
    return '/dashboard';
  }
  return next;
}
